import type { PropsWithChildren } from "react";
import { createContext, useContext, useMemo } from "react";
import { useExperiment } from "@statsig/react-bindings";

import { STATSIG_EXPERIMENT } from "@/services/experiments/constants";

export interface FunnelExperimentContextValue {
  feedbackButtonsShown: boolean;
}

export const FunnelExperimentContext =
  createContext<FunnelExperimentContextValue>({
    feedbackButtonsShown: false,
  });

export function useFunnelExperimentContext() {
  return useContext(FunnelExperimentContext);
}

export function FamilyFunnelExperimentProvider(props: PropsWithChildren) {
  const feedbackButtonsExperiment = useExperiment(
    STATSIG_EXPERIMENT.funnel_test_questions_buttons_feedback,
  );

  const enabled =
    feedbackButtonsExperiment.get("groupSymbol") === "feedback_component";

  const value = useMemo(() => {
    return { feedbackButtonsShown: enabled };
  }, [enabled]);

  return (
    <FunnelExperimentContext.Provider value={value}>
      {props.children}
    </FunnelExperimentContext.Provider>
  );
}

export function ImmigrantFunnelExperimentProvider(props: PropsWithChildren) {
  const imm_funnel_fiance_visa_steps_and_feedback_2025_04_28_experiment =
    useExperiment(
      STATSIG_EXPERIMENT.imm_funnel_fiance_visa_steps_and_feedback_2025_04_28,
    );

  const imm_funnel_fiance_visa_steps_and_feedback_2025_04_28_experiment_enabled =
    imm_funnel_fiance_visa_steps_and_feedback_2025_04_28_experiment.get(
      "groupSymbol",
    ) === "enabled";

  const value = useMemo(() => {
    return {
      feedbackButtonsShown:
        imm_funnel_fiance_visa_steps_and_feedback_2025_04_28_experiment_enabled,
    };
  }, [imm_funnel_fiance_visa_steps_and_feedback_2025_04_28_experiment_enabled]);

  return (
    <FunnelExperimentContext.Provider value={value}>
      {props.children}
    </FunnelExperimentContext.Provider>
  );
}
